import { render, staticRenderFns } from "./AnnouncementGrid.vue?vue&type=template&id=9bddbfa6"
import script from "./AnnouncementGrid.vue?vue&type=script&lang=js"
export * from "./AnnouncementGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports